import { update, isArray } from "lodash-es"
function updateList({ cache, query, variables = null, newItem }) {
  try {
    const queryData = cache.readQuery({
      query,
      variables,
    })

    const firstKey = Object.keys(queryData)[0]

    const prevList = queryData[firstKey]

    const prevElement = prevList.find(
      i => parseInt(i.id) === parseInt(newItem.id)
    )

    if (prevElement) {
      const prevIndex = prevList.indexOf(prevElement)
      cache.writeQuery({
        query,
        variables,
        data: {
          [firstKey]: update(prevList, prevIndex, newItem),
        },
      })
    } else {
      cache.writeQuery({
        query,
        variables,
        data: {
          [firstKey]: isArray(newItem)
            ? newItem.concat(prevList)
            : [newItem].concat(prevList),
        },
      })
    }
  } catch (err) {
    console.error("CACHE-LIST", err)
    return null
  }
}

export { updateList }
